export default __webpack_public_path__ + "static/media/runedflesh.e9c3cc91.png";